import React, { useCallback } from 'react';

import * as Modal from 'app/components/common/modal/Modal';
import { useDispatcher, useSelector } from 'app/store/utils/redux/hooks';

import styles from './Toast.module.css';

interface IToast {}

const Toast: React.FC<IToast> = (props) => {
  const text = useSelector((state) => state.toast.text);
  const isOpen = useSelector((state) => state.toast.isOpen);
  const actions = useDispatcher();

  const handleClose = useCallback(() => {
    actions.toast.setOpenToast(false);
  }, [actions]);

  return (
    <Modal.Item
      visible={isOpen}
      vAlign="flex-start"
      onOutsideClick={handleClose}
    >
      <div className={styles.componentToast}>
        <div className={styles.body}>{text}</div>
      </div>
    </Modal.Item>
  );
};

export default Toast;
